import { useLang } from "@/i18n";

export const StickyCTA = ({ onBook, onEnquire }) => {
  const { t } = useLang();
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0E1613]/90 backdrop-blur-md border-t border-[#1A2A24] grid grid-cols-2"
    >
      <button
        type="button"
        data-testid="sticky-book-call"
        onClick={onBook}
        className="font-mono-label text-[11px] tracking-[0.2em] uppercase py-4 bg-[#B8894B] text-[#0E1613]"
      >
        {t("cta.bookCall")}
      </button>
      <button
        type="button"
        data-testid="sticky-whatsapp"
        onClick={onEnquire}
        className="font-mono-label text-[11px] tracking-[0.2em] uppercase py-4 text-[#EDE7DA] border-l border-[#1A2A24]"
      >
        {t("cta.whatsapp")}
      </button>
    </div>
  );
};
